// src/api/blogCategoryApi.js
import { apiClient, getAuthHeader } from "./apiConfig";

export const fetchBlogCategories = async () => {
  const res = await apiClient.get(`/blog-categories`, {
    ...getAuthHeader(),
  });
  return Array.isArray(res.data) ? res.data : res.data?.data || [];
};

export const createBlogCategory = async (payload) => {
  return apiClient.post(`/blog-categories`, payload, {
    ...getAuthHeader(),
    headers: { "Content-Type": "application/json", ...getAuthHeader().headers },
  });
};

export const updateBlogCategory = async (id, payload) => {
  return apiClient.put(`/blog-categories/${id}`, payload, {
    ...getAuthHeader(),
    headers: { "Content-Type": "application/json", ...getAuthHeader().headers },
  });
};

export const deleteBlogCategory = async (id) => {
  return apiClient.delete(`/blog-categories/${id}`, {
    ...getAuthHeader(),
  });
};
